module.exports = __webpack_public_path__ + "img/联系我们.0da69b1a.png";